import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GraphQLClient } from 'graphql-request';
import {
  clientGetSpendingCategoryEstimates,
  useGraphqlClient,
} from '../graphql';
import { spendingCategoryEstimateKeys } from './queryKeys';
import { SpendingCategoryEstimatesQueryArgs } from './types';

const spendingCategoryEstimatesQuery = (
  gqlClient: GraphQLClient,
  { householdID }: SpendingCategoryEstimatesQueryArgs
) => ({
  enabled: !!householdID,
  queryKey: spendingCategoryEstimateKeys.spendingCategoryEstimates(householdID),
  queryFn: () => {
    if (!householdID) {
      throw new Error('householdID is required');
    }
    return clientGetSpendingCategoryEstimates(gqlClient, { householdID });
  },
});

export function usePrefetchSpendingCategoryEstimates() {
  const queryClient = useQueryClient();
  const gqlClient = useGraphqlClient();

  async function prefetchSpendingCategoryEstimates(
    args: SpendingCategoryEstimatesQueryArgs
  ) {
    return await queryClient.prefetchQuery(
      spendingCategoryEstimatesQuery(gqlClient, args)
    );
  }

  return { prefetchSpendingCategoryEstimates };
}

export const useSpendingCategoryEstimates = (
  args: SpendingCategoryEstimatesQueryArgs
) => {
  const query = useQuery(
    spendingCategoryEstimatesQuery(useGraphqlClient(), args)
  );

  return {
    spendingCategoryEstimatesQuery: query,
    spendingCategoryEstimates: query.data?.items || [],
  };
};
